import classNames from 'classnames'
import { ReactNode } from 'react'

import style from './OrderStepLayout.module.scss'

type OrderStepLayoutProps = {
  children: ReactNode
  className?: string
}

// обёртка для шагов заявки
export function OrderStepLayout({ children, className }: OrderStepLayoutProps) {
  return (
    <section className={classNames(style.stepLayout, className)}>
      {children}
    </section>
  )
}
